import css from "./TemplateChipEditor.module.scss";
import type { RenderSegment } from "./TemplateChipEditor.utils";

interface Props {
  segment: RenderSegment;
  onInvalidChipClick: (end: number) => void;
}

// Сегмент highlight-overlay: либо «прозрачный» текст (валится в textarea
// снизу), либо цветной чип. Валидные чипы pointer-events: none — мышь
// проваливается в textarea. Инвалидные перехватывают hover для tooltip'а.
export const HighlightSegment = ({ segment, onInvalidChipClick }: Props) => {
  if (segment.kind === "text") {
    return <span className={css.text}>{segment.text}</span>;
  }

  const { invalid, raw, backendMessage, end, text } = segment;
  const className = invalid
    ? `${css.chip} ${css.chipInvalid}`
    : `${css.chip} ${css.chipValid}`;
  const title = invalid
    ? backendMessage ?? `Неизвестная переменная "${raw}"`
    : undefined;

  return (
    <span
      className={className}
      title={title}
      onClick={invalid ? () => onInvalidChipClick(end) : undefined}
    >
      {text}
    </span>
  );
};
